/**
 * ProfilPage - Eigene Zugangsdaten als eigene Seite/Tab
 */
import ProfilModal from '@/components/ProfilModal';
import { useTabs } from '@/contexts/TabContext';

export default function ProfilPage() {
  const { closeTab } = useTabs();

  return (
    <div className="max-w-2xl mx-auto py-4" data-testid="profil-page">
      <ProfilModal open={true} onClose={() => closeTab('/admin/profil')} asPage={true} />
    </div>
  );
}
